/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// Sliders
// require('./app/sliders/card-slider');
require('./app/sliders/slider');
require('./app/sliders/mobileSlider');

// ScrollTrigger
// require('./app/scrollTrigger);

// App Requires
require('./app/config');
require('./app/helpers');
require('./app/primary-navigation');
require('./app/videoModal');
require('./app/sliders/featuredSlider');


$(document).ready(function() {
    if($('.mobile-full-width').length > 0) {
        $('.mobile-full-width .row').removeClass('row');
    }

    function updateSiteFooterPadding() {
        var copyrightHeight = $('.copyright').height() + 30;
        $('.site-footer').css('padding-bottom', copyrightHeight + 'px');
    }

    // Initial call to update padding on page load if viewport width is less than 993px
    if ($(window).width() < 993) {
        updateSiteFooterPadding();
    }

    // Bind to resize event to update padding when viewport is resized and width is less than 993px
    $(window).resize(function() {
        if ($(window).width() < 993) {
            updateSiteFooterPadding();
        } else {
            // Reset padding to default value when viewport is larger than 992px
            $('.site-footer').css('padding-bottom', '34px');
        }
    });
});